export const HOME_API_KEY = "home";
